<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <router-link class="text-decoration--none" :to="{ name: 'news' }">
          News & Updates
        </router-link>
        <template v-if="news">
          <v-icon> {{ icons.arrow }} </v-icon>
          <span>{{ news.title }}</span>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4">
      <news-form
        ref="form"
        :blog="news"
        @save="saveNews"
        save-text="Save news"
      />
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import NewsForm from '@/components/BlogForm'
import Blog from '@/models/Blog'
import { each } from 'lodash'
import * as BlogType from '@/utils/consts/BlogType'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'EditNews',

  components: {
    NewsForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      news: null,
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  mounted() {
    this.getNews()
  },

  methods: {
    getNews() {
      Blog.where('type', BlogType.NEWS)
        .$find(this.$route.params.id)
        .then(news => {
          this.news = news
        })
        .catch(() => {
          this.$router.replace({ name: 'news' })
        })
    },

    saveNews(news) {
      const formData = new FormData()
      formData.append('_method', 'PUT')
      each(news, (value, key) => {
        if (value !== null) {
          formData.append(key, value)
        }
      })

      this.$api
        .post(`/blogs/${news.id}`, formData)
        .then(response => {
          this.$toast('News successfully updated!', {
            color: 'green'
          })
          this.$router.replace({ name: 'news' })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.$refs.form.setLoading(false)
        })
    }
  }
}
</script>
